import {
  Conversation,
  ConversationLogItemMessageAdded,
  ConversationMessage,
} from '@stripe-internal/conversations-client';
import {css, view} from '@sail/ui/deprecated';
import {rowForMessage} from './Messages/rowForMessage';
import {useUniversalHelpDotComDesign} from '../../FeatureFlagsProvider';
import {useMessagesTopAnchored} from '../../helpers/useMessagesTopAnchored';
import {
  didUserSelectGetSmartSuggestionsButtonOptionsMessage,
  didUserSelectThumbsDownAdvanceButtonOptionsMessage,
} from '../../helpers/message-added';

function shouldHideButtonOptions(item: ConversationLogItemMessageAdded) {
  if (didUserSelectThumbsDownAdvanceButtonOptionsMessage(item)) {
    return true;
  }

  // if there was a prompt, but we've sent a message to fetch new suggestions,
  // don't even render the row for the prompt which we replaced.
  // we have to do this here as opposed to within ButtonOptionsMessage since
  // this row wraps it and otherwise adds unwanted spacing.
  if (didUserSelectGetSmartSuggestionsButtonOptionsMessage(item)) {
    return true;
  }

  return false;
}

export const MessageAddedRow = ({
  conversation,
  item,
  animated,
  disableInteraction,
  avatar,
  messageRenderer,
}: {
  conversation: Conversation;
  item: ConversationLogItemMessageAdded;
  animated?: boolean;
  disableInteraction?: boolean;
  avatar?: React.ReactNode | null | undefined;
  messageRenderer?: (msg: ConversationMessage) => JSX.Element | null;
}) => {
  const useDotComDesign = useUniversalHelpDotComDesign();
  const {hasTopAnchorFlag} = useMessagesTopAnchored(conversation);

  if (shouldHideButtonOptions(item)) {
    return null;
  }

  if (hasTopAnchorFlag) {
    const rendered = messageRenderer ? messageRenderer(item.message) : null;
    return (
      rendered ||
      rowForMessage({
        conversation,
        item,
        animated,
        avatar,
        disableInteraction,
        disableAvatar: useDotComDesign,
      })
    );
  }

  return (
    <view.div
      className="uh-conversations-message-added"
      data-testid="conversation-log-message-added"
      css={{flex: css.value('1')}}
    >
      {rowForMessage({
        conversation,
        item,
        animated,
        disableInteraction,
        disableAvatar: useDotComDesign,
      })}
    </view.div>
  );
};
